export default __webpack_public_path__ + "8fd6299a870a232cd10d356de03dea84.jpg";